"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("mousetrap");

var tab_1 = require("msteams-ui-styles-core/lib/components/tab");

var React = require("react");

var teams_context_1 = require("../teams-context");

var TabInternal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TabInternal, _React$Component);

  function TabInternal() {
    var _this;

    _classCallCheck(this, TabInternal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabInternal).apply(this, arguments));
    _this.tab = null;
    _this.mousetrap = null;
    _this.itemButtons = [];

    _this.renderTabWithStyle = function (styles) {
      var renderTab = function renderTab(item) {
        var selected = _this.props.selectedTabId === item.id;
        var classes = [styles.normal];

        if (selected) {
          classes.push(styles.active);
        }

        return React.createElement("button", {
          tabIndex: selected ? 0 : -1,
          autoFocus: _this.props.autoFocus && selected,
          key: item.id,
          onMouseDown: function onMouseDown(e) {
            return e.preventDefault();
          },
          onClick: item.onSelect,
          className: classes.join(' '),
          ref: function ref(_ref) {
            if (_ref) {
              _this.itemButtons.push(_ref);
            }
          },
          role: "tab"
        }, item.text);
      };

      return renderTab;
    };

    _this.handleKeyboard = function () {
      if (_this.mousetrap) {
        _this.mousetrap.bind('left', _this.onLeftKey);

        _this.mousetrap.bind('right', _this.onRightKey);
      }
    };

    _this.onRightKey = function (e) {
      e.preventDefault();

      var current = _this.currentIndex();

      var next = current + 1 > _this.itemButtons.length - 1 ? _this.itemButtons.length - 1 : current + 1;

      _this.itemButtons[next].focus();
    };

    _this.onLeftKey = function (e) {
      e.preventDefault();

      var current = _this.currentIndex();

      var next = current - 1 < 0 ? 0 : current - 1;

      _this.itemButtons[next].focus();
    };

    _this.currentIndex = function () {
      return _this.itemButtons.findIndex(function (elm) {
        return elm === document.activeElement;
      });
    };

    return _this;
  }

  _createClass(TabInternal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.tab) {
        this.mousetrap = new Mousetrap(this.tab);
      }

      this.handleKeyboard();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.mousetrap) {
        this.mousetrap.reset();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      this.itemButtons = [];
      var _this$props = this.props,
          context = _this$props.context,
          tabs = _this$props.tabs;
      var styles = tab_1.tab(context);
      var renderTab = this.renderTabWithStyle(styles);
      return React.createElement("div", {
        className: styles.container,
        ref: function ref(_ref2) {
          return _this2.tab = _ref2;
        },
        role: "tablist"
      }, tabs.map(renderTab));
    }
  }]);

  return TabInternal;
}(React.Component);

exports.Tab = teams_context_1.connectTeamsComponent(TabInternal);